import React,{useState}  from 'react'
import {Box,Typography,Container,Button,Menu,MenuItem, CircularProgress} from '@mui/material'
import {useTheme,styled } from '@mui/material/styles'
import MoreIcon from '@mui/icons-material/MoreVert'
import {IconButton} from "@mui/material"
import Divider from '@mui/material/Divider';
import {useNavigate} from 'react-router-dom'
import { add_assessment, add_assessments, add_template,add_templates} from "../Redux/templatesSlice";
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Header from '../Components/Header'
import CustomDialog from '../Components/CustomDialog'
import {useSelector, useDispatch} from 'react-redux';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Snackbar from '@mui/material/Snackbar'
import { CalendarMonth,ArrowDropDownCircleOutlined, CopyAll, EditNote, Groups, Remove, Timelapse, MailOutlineOutlined } from '@mui/icons-material';
import delete_assessment from '../Redux/reducers/delete_assessment';
import delete_user_ass from '../Redux/reducers/delete_user_ass';
import ContentView from '../Components/ContentView'
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { add_reports } from '../Redux/reportsSlice'
import { add_candidates } from '../Redux/settingSlice'

const Accordion = styled((props) => (
	<MuiAccordion disableGutters elevation={4} square {...props} />
))(({ theme }) => ({
	'&:not(:last-child)': {
		borderBottom: 0,
	},
	'&:before': {
		display: 'none',
	},
	borderRadius:10,
	background:"black",
	margin:10
}));

const AccordionSummary = styled((props) => (
<MuiAccordionSummary
	expandIcon={<ArrowDropDownCircleOutlined sx={{ fontSize: 30 }} />}
	{...props}
/>
))(({ theme }) => ({
	background:theme.palette.mode === 'dark'? 'black': 'white',
	flexDirection: 'row',
	marginTop:5,
	marginBottom:5,
	height:150,
	'& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
		transform: 'rotate(90deg)',
	},
	'& .MuiAccordionSummary-content': {
		marginLeft: theme.spacing(1),
		marginBottom: theme.spacing(1),
	}
}));
	
const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
	padding: theme.spacing(2),
	background:theme.palette.mode === 'dark'? 'black' : 'white',
}));

const ContainerBox = styled(Box, {
})(({ theme}) => ({
transition: theme.transitions.create('width', {
easing: theme.transitions.easing.sharp,
duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
    width: 7,
    backgroundColor: '#100101'
  },
'&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ffffff',
    borderRadius: 5
  },
//   background:"#100101",
  minHeight:100,
  maxHeight:300,
  justifyContent:"center",
  alignItems:"center",
  marginBottom:20
}),
);

const QuestionBox = styled(Box, {
})(({ theme}) => ({
transition: theme.transitions.create('width', {
easing: theme.transitions.easing.sharp,
duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
    width: 7,
    backgroundColor: '#100101'
  },
'&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ffffff',
    borderRadius: 5
  },
  minHeight:100,
  maxHeight:500,
  justifyContent:"center",
  alignItems:"center",
  marginBottom:20,
  borderRadius:5
}),
)

const AssessmentInfo = ()=>{

const theme = useTheme()
const [level, setLevel] = useState("");
const navigate = useNavigate()
const [loading, setLoading] = useState(false);
const [deleting, setDeleting] = useState(false);
const [del, setDel] = useState(false);
const [open, setOpen] = React.useState(false);
const [showModal, setShowModal] = React.useState(false);
const [isNext, setIsNext] = React.useState(false);
const [message, setMessage] = React.useState("");
const user = useSelector(state => state?.auth.user);
const assessment = useSelector(state => state?.templates.assessment);
const assessments = useSelector(state => state?.templates.assessments);
const [users, setUsers] = React.useState(assessment?.users || []);
const [anchorEl, setAnchorEl] = React.useState(null);
const [mobileAnchorEl, setMobileAnchorEl] = React.useState(null);
const [expanded, setExpanded] = React.useState(true);
const [mailing, setMailing] = React.useState(false);
const [editing, setEditing] = React.useState(false);
const cameraRef = React.useRef(null);
const dispatch = useDispatch()

const isMenuOpen = Boolean(anchorEl);
const isApiMenuOpen = Boolean(mobileAnchorEl);

const menuId = 'primary-search-account-menu';
const mobileMenuId = 'primary-search-account-menu-mobile';

const handleMobileMenuClose = () => {
setMobileAnchorEl(null);
};

const handleMenuClose = () => {
setAnchorEl(null);
handleMobileMenuClose();
};

const handleMenuOpen = (event) => {
setAnchorEl(event?.currentTarget);
};

const handleChange = () => (event, newExpanded) => {
	setExpanded(newExpanded ? true : false);
};


async function handleUserDelete(userData){

try{
	const data = {
		id:assessment?.id,
		email:userData?.email,
		token:user?.accessToken
	}

	console.log(data)

	await delete_user_ass(data,setOpen,setMessage,setUsers,setDel)

}catch(err){
	console.log(err)
}

}

const renderMenu = (
	<Menu
		anchorEl={anchorEl}
		anchorOrigin={{
		vertical: 'top',
		horizontal: 'right',
		}}
		id={menuId}
		keepMounted
		transformOrigin={{
		vertical: 'top',
		horizontal: 'right',
		}}
		open={isMenuOpen}
		onClose={handleMenuClose}
	>
	{(user?.email === assessment?.email) && (
		<MenuItem sx={{width:250,height:40}} 
			onClick={async (e)=>{
				e?.preventDefault()
				console.log(assessment?.users)
				dispatch(add_candidates(assessment?.users))
				navigate("/sendMail")
				handleMenuClose()
			}}>
				<IconButton
					size="large"
					aria-label="account of current user"
					aria-controls="primary-search-account-menu"
					aria-haspopup="true"
					color="inherit"
					>
					<MailOutlineOutlined fontSize="small" sx={{color:"red"}}/>
				</IconButton>
				<p style={{marginLeft:10,fontSize:12}}>Send Mail</p>
			</MenuItem>
		)
		}
		{(user?.email === assessment?.email) && (
		<MenuItem sx={{width:250,height:40}} 
			onClick={async (e)=>{
				e?.preventDefault()

				const data = {
					id:assessment?.id,
					email:user?.email,
					
				}

				const token = user?.accessToken
				
				await delete_assessment(data,token,add_assessments,add_assessment,assessments,dispatch,setDeleting,setMessage,setOpen,navigate)
				handleMenuClose()
			}}>
				<IconButton
					size="large"
					aria-label="account of current user"
					aria-controls="primary-search-account-menu"
					aria-haspopup="true"
					color="inherit"
					disabled={deleting ? true : false}
					>
					{
						deleting ? <CircularProgress size={18} sx={{color:"black"}}/> : <Remove fontSize="small" sx={{color:"red"}}/>
					}
				</IconButton>
				<p style={{marginLeft:10,fontSize:12}}>Delete</p>
			</MenuItem>
			)
		}
		<MenuItem sx={{width:250,height:40}} 
			onClick={(e)=>{
				e?.preventDefault()
				navigator.clipboard.writeText(assessment?.id)
				setMessage("Assessment id copied")
				setOpen(true)
				handleMenuClose()
			}}>
			<IconButton
				size="large"
				aria-controls="primary-search-account-menu"
				aria-haspopup="true"
				color="inherit"
				>
				<CopyAll sx={{color:"yellow"}} fontSize="small"/>
			</IconButton>
			<p style={{marginLeft:10,fontSize:12}}>Copy Code</p>
		</MenuItem>
	</Menu>
	);
	
const handleSnackbarOpen = ()=>{
	setOpen(true)
}

const handleSnackbarClose = ()=>{
	setOpen(false)
}

const DescriptionText = ({text,limit})=>{
	const displayText = text?.length > limit ? text?.substring(0,limit) + '...' : text;
	return <Typography color="white" ml={1} fontSize={13}> {displayText} </Typography>
  }

	return(
		<Box width="100%">
			<Header title="Create Assessment">
				<Breadcrumbs aria-label="breadcrumb">
					<Link  sx={{fontSize:12,color:"gray"}} underline="hover" color="inherit" href="/dashboard">
						Dashboard
					</Link>
					<Typography  sx={{fontSize:12,color:"gray"}}>Assessment Info </Typography>
			</Breadcrumbs>			
			</Header>
			<Container>
				<Snackbar 
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}} 
					message={message} 
					onClose={handleSnackbarClose} 
					open={open} 
					autoHideDuration={2000}
				/>
				<Box m={2} sx={{borderRadius:5,padding:2,width:{xs:450,md:"100%",paddingLeft:1}}}>
					<Box display="flex" width="95%" flexDirection="row" justifyContent="space-between" alignItems="center">
						<Typography ml={3} style={{fontSize:16,fontWeight:400,fontFamily:"dinofans"}}>
							Assessment Info
						</Typography>
						<Box>
							<Button onClick={(e)=>{
								e?.preventDefault()
								dispatch(add_assessment(assessment))
								navigate("/tryAssessment")
							}} sx={{backgroundColor:"gold",color:"black",fontSize:{xs:10,md:12},height:30,fontFamily:"dinofans",margin:1}} variant="contained">
								Try 
							</Button>
							<Button onClick={async (e)=>{
								e?.preventDefault()
								await dispatch(add_assessment(assessment))
								await dispatch(add_reports(assessment?.reports))
								navigate("/assessmentReport")
							}} sx={{backgroundColor:"maroon",color:"#fff",fontSize:{xs:10,md:12},height:30,fontFamily:"dinofans",margin:1,display:{xs:"none",md:"inline-block"}}} variant="contained">
								Report
							</Button>
							<IconButton onClick={()=>{
								setShowModal(true)
							}}>
								<Typography pr={1} color="white" fontSize={14} >
									{assessment?.users?.length}
								</Typography>							
								<Groups fontSize='25' style={{color:"gray"}}/>
							</IconButton>
							<IconButton sx={{display:{xs:"none",md:"inline-block"}}} onClick={handleMenuOpen}>
								<MoreIcon fontSize="small"/>
							</IconButton>
						</Box>
					</Box>
					{renderMenu}
					<Box display="flex" flexWrap="wrap" justifyContent="space-between" m={2} sx={{backgroundColor:"black"}}>
						<Box sx={{margin:1,padding:2,color:"gray",width:{md:"40%"}}}>
							<Typography sx={{fontFamily:"dinofans",marginBottom:1}}>
								Title
							</Typography>
							<DescriptionText limit={100} text={assessment?.name} />
						</Box>
						<Box sx={{margin:1,padding:2,color:"gray",width:{md:"20%"}}}>
							<Typography sx={{fontFamily:"dinofans",marginBottom:1}}>
								Type
							</Typography>
							<DescriptionText limit={100} text={assessment?.type} />
						</Box>
						<Box sx={{margin:1,padding:2,color:"gray",width:{md:"20%"}}}>
							<Typography sx={{fontFamily:"dinofans",marginBottom:1}}>
								Level
							</Typography>
							<DescriptionText limit={100} text={assessment?.level} />
						</Box>
						<Box sx={{display:"flex",flexDirection:"row",justifyContent:"space-evenly",width:"100%",alignContent:"center",marginBottom:3}}>
							<Box sx={{display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
								<IconButton>
									<CalendarMonth style={{color:"gray"}}/>
								</IconButton>
								<Typography color="white" fontSize={14} width={80}>
									{assessment?.start_date}
								</Typography>
							</Box>
							<Box sx={{display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
								<IconButton>
									<CalendarMonth style={{color:"gray"}}/>
								</IconButton>
								<Typography color="white" fontSize={14} width={40}>
									{assessment?.start_moment}
								</Typography>
							</Box>
							<Box sx={{display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
								<IconButton>
									<Timelapse style={{color:"gray"}}/>
								</IconButton>
								<Typography color="white" fontSize={14} width={60}>
									{assessment?.time} min
								</Typography>
							</Box>
						</Box>
						<Box sx={{margin:1,padding:2,color:"gray",width:{md:"80%"}}}>
							<Typography sx={{fontFamily:"dinofans",marginBottom:1}}>
								Description
							</Typography>
							<DescriptionText limit={300} text={assessment?.description} />
						</Box>
					</Box>
					<Box justifyContent="flex-start" alignItems="flex-start" width="100%" ml={3}>
						<Typography mt={1} mb={1} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans",color:"gold"}}>
							Sections
						</Typography>								
					</Box>
					<ContainerBox>
						{
							assessment?.sections?.map((item,index)=>(
								<Accordion  key={index} sx={{width:{xs:"100%",md:"95%"},borderRadius:5,margin:1,marginBottom:3}} expanded={expanded} onChange={handleChange(true)}>
									<AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
										<Box sx={{height:150}}>
											<Typography mt={1} mb={1} style={{fontSize:11,fontWeight:400,fontFamily:"dinofans",color:"gold"}}>
												{index+1} # {item?.title}
											</Typography>
											<ContentView title="Description" content={item?.description}/>
											<Box sx={{display:"flex",flexDirection:"row",justifyContent:"space-evenly",width:"100%",alignContent:"center",marginBottom:3}}>
												<Box sx={{display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
													<IconButton>
														<CalendarMonth style={{color:"gray"}}/>
													</IconButton>
													<Typography color="white" fontSize={12} width={80}>
														{item?.level}
													</Typography>
												</Box>
												<Box sx={{display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
													<IconButton>
														<CalendarMonth style={{color:"gray"}}/>
													</IconButton>
													<Typography color="white" fontSize={12} width={40}>
														{item?.language}
													</Typography>
												</Box>
												<Box sx={{display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
													<IconButton>
														<Timelapse style={{color:"gray"}}/>
													</IconButton>
													<Typography color="white" fontSize={12} width={60}>
														{item?.duration} min
													</Typography>
												</Box>
											</Box>
										</Box>
									</AccordionSummary>
									<AccordionDetails  sx={{justifyContent:"center",alignItems:"center",ml:1}}>
										{
											item?.questions?.map((itm,index)=>(
												<QuestionBox key={index}>
													<Typography mt={1} m={1} style={{fontSize:12,fontWeight:400,fontFamily:"dinofans",color:"gold"}}>
														{index+1} # Question
													</Typography>
													<Typography mt={1} m={1} style={{fontSize:12,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
														Question
													</Typography>
													<Typography mt={1} m={1} style={{fontSize:12,fontWeight:400,color:"#fff"}}>
														{itm?.question}
													</Typography>
													{
														itm?.hasImage && (
															<Box sx={{justifyContent:"center",alignItems:"center",width:"100%",marginLeft:5}}>
																<img resizemode="cover" src={itm?.imageUrl} width={100} height={100} style={{borderRadius:5}}/>
															</Box>
														)
													}
													{
														itm?.hasAudio && (
															<Box sx={{justifyContent:"center",alignItems:"center"}}>
																<audio
																	src={itm?.audioUrl}
																	controls
																	style={{width:250,height:50}}
																/>
															</Box>
														)
													}
													{
														itm?.hasVideo && (
															<Box ml={2} width="100%">
																<video src={itm?.videoUrl} controls style={{width:200,height:150}}/>
															</Box>
														)
													}
													<Typography mt={2} m={1} style={{fontSize:12,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
														Type of the question
													</Typography>
													<Typography mt={1} m={1} style={{fontSize:12,fontWeight:400,color:"#fff"}}>
														{itm?.question_type}
													</Typography>
													<Typography mt={2} m={1} style={{fontSize:12,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
														Possible answer
													</Typography>
													<Typography mt={1} m={1} style={{fontSize:12,fontWeight:400,color:"#fff"}}>
														{itm?.responses[0]}
													</Typography>
												</QuestionBox>
											))
										}
									</AccordionDetails>
								</Accordion>
							))
						}
					</ContainerBox>
				</Box>
				<CustomDialog massDisabled={true} visible={showModal} deleting={del} setVisible={setShowModal} handleUserDelete={handleUserDelete} data={users.length > 0 ? users : assessment?.users}/>
			</Container>
		</Box>
		)
}

export default AssessmentInfo